import React, { useEffect, useRef } from 'react';
import { ArithmeglyphsStore } from '../ArithmeglyphsStore';
import { ConfirmationTypes, maybeConfirmAndProceed } from '../arithmeglyphsUtils';
import RevealConfirmationDialogCluster from './RevealConfirmationDialogCluster';
import { useIsMobileDimensions } from '../../shared/utils';
import { isMobile } from 'react-device-detect';
import { IconButton } from '@mui/material';
import { Support } from '@mui/icons-material';

const AssistToolbar = () => {
  const { completed, combinedDropdownIsOpen, checkDropdownIsOpen, revealDropdownIsOpen }
    = ArithmeglyphsStore.useState();
  const ref = useRef<any>(null);

  const useMobileDimensions = useIsMobileDimensions() || isMobile;

  // If a click is outside the toolbar, it closes all menus.
  // A click within the menu is handled by togglesMenus, which closes all but the clicked one.
  useEffect(() => {
    const onClickOutside = (e: any) => {
      if (ref.current && !ref.current.contains(e.target)) {
        ArithmeglyphsStore.update(s => {
          s.revealDropdownIsOpen = false;
          s.checkDropdownIsOpen = false;
          s.combinedDropdownIsOpen = false;
        });
        document.removeEventListener('click', onClickOutside);
      }
    };
    if (checkDropdownIsOpen || revealDropdownIsOpen || combinedDropdownIsOpen) {
      document.addEventListener('click', onClickOutside);
    }
    return () => {
      document.removeEventListener('click', onClickOutside);
    };
  }, [checkDropdownIsOpen, revealDropdownIsOpen, combinedDropdownIsOpen]);

  const toggleMenus = (index: number) => {
    switch (index) {
      case 1:
        ArithmeglyphsStore.update(s => {
          s.checkDropdownIsOpen = !s.checkDropdownIsOpen;
          s.revealDropdownIsOpen = false;
          s.combinedDropdownIsOpen = false;
        });
        break;
      case 2:
        ArithmeglyphsStore.update(s => {
          s.checkDropdownIsOpen = false;
          s.revealDropdownIsOpen = !s.revealDropdownIsOpen;
          s.combinedDropdownIsOpen = false;
        });
        break;
      case 3:
        ArithmeglyphsStore.update(s => {
          s.checkDropdownIsOpen = false;
          s.revealDropdownIsOpen = false;
          s.combinedDropdownIsOpen = !s.combinedDropdownIsOpen;
        });
        break;
    }
  };

  if (useMobileDimensions) {
    return (
      <div ref={ref} className="assistToolbar mobileToolbar arithmeglyphsToolbar">
        <RevealConfirmationDialogCluster/>
        <div className="dropdownButton" onClick={() => {
          ArithmeglyphsStore.update(s => {
            s.combinedDropdownIsOpen = !s.combinedDropdownIsOpen;
          });
        }}>
          <div className="buttonLabel">
            <IconButton disableRipple disableTouchRipple>
              <Support/>
            </IconButton>
          </div>
          <ul className={`dropdownMenu revealMenu ${combinedDropdownIsOpen ? 'open' : ''}`}>
            <li onClick={() => maybeConfirmAndProceed(ConfirmationTypes.CheckGlyph)}>
              Check Glyph
            </li>
            <li onClick={() => maybeConfirmAndProceed(ConfirmationTypes.CheckPuzzle)}>
              Check Puzzle
            </li>
            <li onClick={() => maybeConfirmAndProceed(ConfirmationTypes.RevealGlyph)}>
              Reveal Glyph
            </li>
            <li onClick={() => maybeConfirmAndProceed(ConfirmationTypes.RevealPuzzle)}>
              Reveal Puzzle
            </li>
          </ul>
        </div>
      </div>
    );
  }

  return (
    <div ref={ref} className="assistToolbar arithmeglyphsToolbar">
      <RevealConfirmationDialogCluster/>
      <div className="dropdownButton" onClick={() => toggleMenus(1)}>
        <div className="buttonLabel">Check</div>
        <ul className={`dropdownMenu checkMenu ${checkDropdownIsOpen ? 'open' : ''}`}>
          <li onClick={() => {
            maybeConfirmAndProceed(ConfirmationTypes.CheckGlyph);
          }}>Glyph</li>
          <li onClick={() => {
            maybeConfirmAndProceed(ConfirmationTypes.CheckPuzzle);
          }}>Puzzle</li>
        </ul>
      </div>
      <div className="dropdownButton" onClick={() => toggleMenus(2)}>
        <div className="buttonLabel">
          Reveal
        </div>
        <ul className={`dropdownMenu revealMenu ${revealDropdownIsOpen ? 'open' : ''}`}>
          <li onClick={() => {
            maybeConfirmAndProceed(ConfirmationTypes.RevealGlyph);
          }}>Glyph</li>
          <li onClick={() => {
            maybeConfirmAndProceed(ConfirmationTypes.RevealPuzzle);
          }}>Puzzle</li>
        </ul>
      </div>
    </div>
  );
};

export default AssistToolbar;